import { ApiClient } from '../api.client';
import { Payment } from '../../models';

export type PaymentableEndpoint =
  | 'sale-dockets'
  | 'docket'
  | 'booking'
  | 'repair-dockets';

export abstract class AbstractPaymentService {
  protected abstract docketTypePrefix: PaymentableEndpoint;
  private resourceEndpoint = 'payments';

  constructor(protected http: ApiClient) {}

  public getAll() {
    return this.http.get<Payment[]>(this.resourceEndpoint);
  }

  public getPaymentsForDocket(paymentableId: number) {
    return this.http.get<Payment[]>(
      `${this.docketTypePrefix}/${paymentableId}/${this.resourceEndpoint}`
    );
  }

  public addPayment(paymentableId: number, payment: Partial<Payment>) {
    return this.http.post<Payment>(
      `${this.docketTypePrefix}/${paymentableId}/${this.resourceEndpoint}`,
      payment
    );
  }

  delete(paymentableId: number, id: number) {
    return this.http.delete(
      `${this.docketTypePrefix}/${paymentableId}/${this.resourceEndpoint}/${id}`
    );
  }
}
